import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.checkliste-veranstaltungs-typen-deaktivieren';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenChecklisteVeranstaltungsTypenDeaktivierenEffects {

    ChecklisteVeranstaltungsTypenDeaktivieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_CHECKLISTE_VERANSTALTUNGS_TYPEN_DEAKTIVIEREN),
        mergeMap((x: ac.PostChecklisteVeranstaltungsTypenDeaktivierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postChecklisteVeranstaltungsTypenDeaktivieren(x.checklisteRequest).pipe(
                map((result: any) => {
                    return new ac.PostChecklisteVeranstaltungsTypenDeaktivierenErfolgreichAction(result, x.checklisteRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostChecklisteVeranstaltungsTypenDeaktivierenFehlerAction(error, x.checklisteRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ChecklisteCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ChecklisteCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.ChecklisteCommandService);
        }
        return this.service;
    }
}
